import $ from 'jquery';
import { showLoader, hideLoader } from 'common/utils/rbacHelpers';
import { createQueryString } from 'common/utils/queryStringUtils';
import { RBAC_PRODUCT_AREAS } from 'common/constants/rbacProductAreas';

$(function () {
  var maxSelectedItemsToRender = 500;
  var currentRequest = null;
  const loaderElementName = 'groups-loading-icon';
  const NODE_TYPE_GROUP = 'group';
  const NODE_TYPE_EMPLOYEE = 'employee';

  function isEqual(a, b) {
    if (Object.keys(a).length !== Object.keys(b).length) {
      return false;
    }

    for (const key in a) {
      const a_value = a[key];
      const b_value = b[key];
      if (
        (a_value instanceof Object && !isEqualObjects(a_value, b_value)) ||
        (!(a_value instanceof Object) && a_value !== b_value)
      ) {
        return false;
      }
    }
    return true;
  }

  function uniqWith(arr, fn) {
    return arr.filter((element, index) => arr.findIndex(step => fn(element, step)) === index);
  }

  function differenceWith(arr, values, comparator) {
    return arr.filter(item => !values.some(value => comparator(item, value)));
  }

  function checkGroupSelection(groupId, returnIndex) {
    var selectedGroupsArray = $('#groups-select').data('selected-groups-nodes') || [];

    var groupIndex = selectedGroupsArray.findIndex(function (group) {
      return group.nodeId == groupId;
    });

    return returnIndex ? groupIndex : groupIndex !== -1;
  }

  function clearNextPage($container) {
    $container.data('next-page', '');
  }

  function fetchGroups(search, callBack) {
    var $container = $('#groups-items-container');
    var includeDeactivated = $('#include_deactivated').prop('checked');
    const path = '/api/v1/reporting_groups';
    var paramsStr = createQueryString({
      active: includeDeactivated ? '' : true,
      ...(search && { search }),
      product_area: RBAC_PRODUCT_AREAS.FEEDBACK,
    });

    if (currentRequest) currentRequest.abort();

    clearNextPage($container);
    showLoader(loaderElementName);
    currentRequest = $.get(`${path}?${paramsStr}`, callBack);
  }

  function fetchMembers(groupId, callBack) {
    var $container = $('#groups-items-container');
    var includeDeactivated = $('#include_deactivated').prop('checked');
    const path = `/api/v1/reporting_groups/${groupId}/members`;
    var paramsStr = createQueryString({
      active: includeDeactivated ? '' : true,
      product_area: RBAC_PRODUCT_AREAS.FEEDBACK,
    });

    if (currentRequest) currentRequest.abort();

    clearNextPage($container);
    showLoader(loaderElementName);
    currentRequest = $.get(`${path}?${paramsStr}`, callBack);
  }

  function fetchAllMembers(groupId, callBack) {
    var $container = $('#groups-items-container');
    var includeDeactivated = $('#include_deactivated').prop('checked');
    const path = `/api/v1/reporting_groups/${groupId}/all_members`;
    var paramsStr = createQueryString({
      active: includeDeactivated ? '' : true,
      product_area: RBAC_PRODUCT_AREAS.FEEDBACK,
    });

    if (currentRequest) currentRequest.abort();
    showLoader(loaderElementName);
    currentRequest = $.get(`${path}?${paramsStr}`, callBack);
  }

  function fetchEmployeesInfo(nodeIds, callBack) {
    var url = `/api/v2/profiles/by_employee_id`;
    var params = {
      employee_ids: nodeIds,
      attributes: ['comma_name', 'custom_employee_id', 'employee_id'],
    };

    currentRequest = $.post(url, params, callBack);
  }

  function fetchGroupsInfo(nodeIds, callBack) {
    var url = '/api/v1/reporting_groups';
    var paramsStr = createQueryString({
      ids: nodeIds,
    });

    currentRequest = $.get(`${url}?${paramsStr}`, callBack);
  }

  function requestNextPage($container, data) {
    if (data._links && data._links.next) {
      $container.data('next-page', data._links.next.href);
    } else {
      $container.data('next-page', '');
    }
  }

  function addGroupNode(nodeItem, searchText) {
    if (nodeItem && !nodeItem.filterable) return false;

    var $container = $('#groups-items-container');
    var isSelected = checkGroupSelection(nodeItem.id);
    var regEx = new RegExp(searchText, 'gi');

    var displayName =
      searchText ?
        nodeItem.name.replace(regEx, function (text) {
          return `<span class="background-light-blue">${text}</span>`;
        })
      : nodeItem.name;

    $container.append(`
      <li class="node folder" data-node-name="${nodeItem.name}" data-node-id="${nodeItem.id}">
        <div class="add-section padding-right-medium">
          <input ${
            isSelected ? 'checked' : ''
          } class="add button js-employee-checkbox unstyled hover-pointer" type="checkbox">
        </div>
        <div class="node-section">
          <div class="name-section">
            ${displayName}
          </div>
          <div class="icon-section hover-pointer padding-right-medium">
            <i class="fas fa-angle-right" aria-hidden="true"></i>
          </div>
        </div>
      </li>
    `);
  }

  function addGroupMemberNode(_index, nodeItem) {
    var $container = $('#groups-items-container');
    var groupId = $container.data('group-id');
    var selectedArray = $('#groups-select').data('selected-nodes') || [];

    var isGroupSelected = checkGroupSelection(groupId);
    var isSelected =
      isGroupSelected ||
      selectedArray.findIndex(item => item.nodeId === nodeItem.employee_id) !== -1;

    $container.append(`
      <li class="node single" data-node-name="${
        nodeItem.employee_name
      }" data-node-id="${nodeItem.employee_id}">
        <div class="add-section padding-right-medium">
          <input ${
            isSelected ? 'checked' : ''
          } class="add button js-employee-checkbox unstyled hover-pointer" type="checkbox">
        </div>
        <div class="node-section">
          <div class="name-section">
            ${nodeItem.employee_name}
          </div>
          <div class="icon-section">
          </div>
        </div>
      </li>
    `);
  }

  function renderGroupHeader(nodeId, nodeName) {
    var $container = $('#groups-items-container');

    $container.append(`
      <li class="folder-header padding-medium">
        <div class="tree-back-btn text-green hover-pointer">
          <i class="fas fa-angle-left" aria-hidden="true"></i>
          <span>back</span>
        </div>
        <div class="folder-name">
          <strong>${nodeName}</strong>
        </div>
      </li>
    `);
  }

  function renderGroup(groupId, groupName) {
    var $container = $('#groups-items-container');

    $container.data('group-id', groupId);
    $container.html('');
    $container.removeClass('groups');
    $container.addClass('members');

    renderGroupHeader(groupId, groupName);

    fetchMembers(groupId, function (data) {
      hideLoader(loaderElementName);
      if (data && data.items) {
        $.each(data.items, addGroupMemberNode);

        requestNextPage($container, data);
      }
    });
  }

  function renderRootGroups() {
    var $container = $('#groups-items-container');

    $container.removeClass('members');
    $container.addClass('groups');

    fetchGroups(null, function (data) {
      hideLoader(loaderElementName);
      if (data && data.items) {
        $container.html('');
        $.each(data.items, function (_index, nodeItem) {
          addGroupNode(nodeItem);
        });
        requestNextPage($container, data);
      }
    });
  }

  var handleAjaxSearch = function () {
    var searchText = $('#js-groups-tree-search input').val().trim();
    var $container = $('#groups-items-container');

    $container.html('');
    $container.removeClass('members');
    $container.addClass('groups');

    if (searchText.length > 0) {
      fetchGroups(searchText, function (data) {
        hideLoader(loaderElementName);
        if (data && data.items) {
          $.each(data.items, function (_index, nodeItem) {
            addGroupNode(nodeItem, searchText);
          });
          requestNextPage($container, data);
        }
      });
    } else {
      clearNextPage($container);
      $container.html('');
    }
  };

  var handleTeamsItemsScroll = function () {
    var $container = $('#groups-items-container');
    var isGroups = $container.hasClass('groups');
    var nextPageUrl = $('#groups-items-container').data('next-page');
    var searchText = $('#js-groups-tree-search input').val().trim();

    if ($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight) {
      if (nextPageUrl === '') {
        return;
      }

      if (currentRequest) currentRequest.abort();

      clearNextPage($container);
      showLoader(loaderElementName);
      currentRequest = $.get(nextPageUrl, function (data) {
        $.each(data.items, function (_index, nodeItem) {
          if (isGroups) {
            addGroupNode(nodeItem, searchText);
          } else {
            addGroupMemberNode(_index, nodeItem, searchText);
          }
        });
        requestNextPage($container, data);
      });
    }
  };

  function updateEmployeeIds() {
    var selectedArray = $('#groups-select').data('selected-nodes') || [];

    var employeeIds = selectedArray.map(function (member) {
      return member.nodeId;
    });

    $('#employee_ids, #group_ids').val(employeeIds.join()).trigger('change');
  }

  function updateReportingGroupIds() {
    var selectedGroupsArray = $('#groups-select').data('selected-groups-nodes') || [];

    var groupIds = selectedGroupsArray.map(function (group) {
      return group.nodeId;
    });

    $('#reporting_group_ids').val(groupIds.join()).trigger('change');
  }

  function renderSelections() {
    var $root = $('#groups-select');
    var $selectionsContainer = $('#groups-selected-items-container');

    var selectedArray = $root.data('selected-nodes') || [];
    var selectedGroupsArray = $('#groups-select').data('selected-groups-nodes') || [];
    var selectedGroupsArrayWithType = selectedGroupsArray.map(function (group) {
      return { ...group, type: NODE_TYPE_GROUP };
    });
    var selectionsArray = [...selectedGroupsArrayWithType, ...selectedArray];

    var renderCount =
      selectionsArray.length > maxSelectedItemsToRender ?
        maxSelectedItemsToRender
      : selectionsArray.length;

    var renderedStr = '';

    for (var i = 0; i < renderCount; i++) {
      renderedStr += `
        <div class="groups-selected-member">
          ${selectionsArray[i].nodeName}
          <span data-node-id="${selectionsArray[i].nodeId}" data-node-type="${
            selectionsArray[i].type === NODE_TYPE_GROUP ? NODE_TYPE_GROUP : NODE_TYPE_EMPLOYEE
          }" class="deselect-member cursor-pointer"><i class="fas fa-times" aria-hidden="true"></i></span>
        </div>
      `;
    }
    if (selectionsArray.length > maxSelectedItemsToRender) {
      var moreSelectedCount = selectionsArray.length - maxSelectedItemsToRender;
      renderedStr += `
        <div class="font-size-small padding-small">and ${moreSelectedCount} more.</div>
      `;
    }
    $selectionsContainer.html(renderedStr);
  }

  function updateSelection() {
    var selectedArray = $('#groups-select').data('selected-nodes') || [];
    var $container = $('#groups-items-container');

    $('li.node.single', $container).each(function (_index, node) {
      var nodeId = $(node).data('node-id');
      var isSelected = selectedArray.findIndex(item => item.nodeId === nodeId) !== -1;

      $('.js-employee-checkbox', $(node)).prop('checked', isSelected);
    });

    $('li.node.folder', $container).each(function (_index, node) {
      var nodeId = $(node).data('node-id');
      var isSelected = checkGroupSelection(nodeId);

      $('.js-employee-checkbox', $(node)).prop('checked', isSelected);
    });
  }

  function selectNode(nodeId, nodeName) {
    var $root = $('#groups-select');
    var selectedArray = $root.data('selected-nodes') || [];

    selectedArray.push({ nodeId, nodeName });
    $root.data('selected-nodes', uniqWith(selectedArray, isEqual));

    renderSelections();
    updateEmployeeIds();
  }

  function deselectNode(employeeId) {
    var $root = $('#groups-select');
    var groupId = $('#groups-items-container').data('group-id');

    var selectedArray = $root.data('selected-nodes') || [];
    var selectedGroupsArray = $('#groups-select').data('selected-groups-nodes') || [];

    var employeeIndex = selectedArray.findIndex(item => item.nodeId === employeeId);

    if (employeeIndex !== -1) {
      selectedArray.splice(employeeIndex, 1);
    }

    var groupIndex = checkGroupSelection(groupId, true);

    if (groupIndex !== -1) {
      selectedGroupsArray.splice(groupIndex, 1);

      fetchAllMembers(groupId, function (data) {
        hideLoader(loaderElementName);
        if (data && data.items) {
          var members = Object.values(data.items).reduce(function (acc, member) {
            if (member.employee_id !== employeeId) {
              acc.push({
                nodeId: member.employee_id,
                nodeName: member.employee_name,
              });
            }
            return acc;
          }, []);

          $('#groups-select').data(
            'selected-nodes',
            uniqWith(selectedArray.concat(members), isEqual)
          );
          renderSelections();
          updateEmployeeIds();
          updateReportingGroupIds();
        }
      });
    } else {
      $root.data('selected-nodes', selectedArray);
      renderSelections();
      updateEmployeeIds();
    }
  }

  function selectGroup(groupId, nodeName) {
    var selectedGroupsArray = $('#groups-select').data('selected-groups-nodes') || [];

    selectedGroupsArray.push({ nodeId: groupId, nodeName });
    $('#groups-select').data('selected-groups-nodes', selectedGroupsArray);

    renderSelections();
    updateReportingGroupIds();
  }

  function deselectGroup(groupId) {
    var selectedGroupsArray = $('#groups-select').data('selected-groups-nodes') || [];

    selectedGroupsArray.splice(
      selectedGroupsArray.findIndex(group => group.nodeId === groupId),
      1
    );
    $('#groups-select').data('selected-groups-nodes', selectedGroupsArray);

    renderSelections();
    updateReportingGroupIds();
  }

  function handleChangeCheckbox() {
    var $nodeLi = $(this).closest('li.node');
    var isFolder = $nodeLi.hasClass('folder');
    var nodeId = $nodeLi.data('node-id');
    var nodeName = $nodeLi.data('node-name');
    var isChecked = this.checked;

    if (isChecked) {
      if (isFolder) {
        selectGroup(nodeId, nodeName);
      } else {
        selectNode(nodeId, nodeName);
      }
    } else if (isFolder) {
      deselectGroup(nodeId, nodeName);
    } else {
      deselectNode(nodeId, nodeName);
    }
  }

  function removeNodeFromSelection() {
    var nodeId = $(this).data('node-id');
    var nodeType = $(this).data('node-type');

    if (nodeType === NODE_TYPE_GROUP) {
      deselectGroup(nodeId);
    } else {
      deselectNode(nodeId);
    }

    updateSelection();
  }

  function clearAllSelection() {
    $('#groups-select').data('selected-groups-nodes', []);
    $('#groups-select').data('selected-nodes', []);
    $('#js-groups-tree-search input').val('');
    handleAjaxSearch();
    updateSelection();
    renderSelections();
    updateEmployeeIds();
    updateReportingGroupIds();
  }

  function bindNodesClicks($root) {
    $root.on('click', '.node-section', function () {
      var $target = $(this);
      var $nodeLi = $target.parent();
      var nodeId = $nodeLi.data('node-id');
      var nodeName = $nodeLi.data('node-name');
      var isFolder = $nodeLi.hasClass('folder');

      if (isFolder) {
        setTimeout(function () {
          renderGroup(nodeId, nodeName);
        }, 0);
      }
    });

    $root.on('click', '.tree-back-btn', function () {
      var searchText = $('#js-groups-tree-search input').val().trim();

      if (searchText) {
        setTimeout(handleAjaxSearch, 0);
      } else {
        setTimeout(renderRootGroups, 0);
      }
    });
  }

  function debounce(func, delay, { leading } = {}) {
    let timerId;

    return function (...args) {
      const ctx = this;

      if (!timerId && leading) {
        func.apply(ctx, args);
      }
      clearTimeout(timerId);

      timerId = setTimeout(() => func.apply(ctx, args), delay);
    };
  }

  function bindChange($root) {
    $('#js-groups-tree-search input', $root).on('input', debounce(handleAjaxSearch, 500));
  }

  function bindSelect($root) {
    $root.on('click', '.js-employee-checkbox', function (e) {
      e.stopPropagation();
    });
    $root.on('change', '.js-employee-checkbox', handleChangeCheckbox);

    $root.on('click', '.deselect-member', removeNodeFromSelection);
  }

  function bindClearSelection($root) {
    $root.on('click', '.link.js-deselect-all', clearAllSelection);
  }

  function bindDeactivated() {
    var $checkbox = $('.js-filter-deactivated :checkbox');
    $checkbox.change(function () {
      clearAllSelection();
    });
  }

  function bindClearFilters() {
    $('.js-clear-filters').click(clearAllSelection);
  }

  function bindScroll() {
    var $container = $('#groups-items-container');

    $container.on('scroll', handleTeamsItemsScroll);
  }

  function bindFocus($root) {
    var $container = $('#groups-items-container');

    $('#js-groups-tree-search input', $root).on('focus', function () {
      var searchText = $('#js-groups-tree-search input').val().trim();

      if (!$root.hasClass('opened')) {
        $root.addClass('opened');
        if (searchText) {
          setTimeout(handleAjaxSearch, 0);
        } else {
          setTimeout(renderRootGroups, 0);
        }
      }
    });
  }

  function closeDropDown($root) {
    var $container = $('#groups-items-container');

    clearNextPage($container);
    $root.removeClass('opened');
  }

  function restoreState() {
    if ($('#team_or_group').val() !== 'groups') {
      return;
    }

    var groupIds = $('#reporting_group_ids').val();
    var employeeIds = $('#employee_ids').val();

    if (groupIds) {
      var selectedGroupsArray = groupIds.split(',') || [];

      fetchGroupsInfo(selectedGroupsArray, function (data) {
        if (data && data.items.length > 0) {
          var selectedArray = data.items.map(function (group) {
            return {
              nodeId: group.id,
              nodeName: group.name,
            };
          });
          $('#groups-select').data('selected-groups-nodes', selectedArray);

          updateSelection();
          renderSelections();
        }
      });
    }

    if (employeeIds) {
      var selectedArray = $('#employee_ids').val().split(',') || [];

      fetchEmployeesInfo(selectedArray, function (data) {
        if (data && Array.isArray(Object.keys(data))) {
          var selectedArray = Object.keys(data).map(function (employeeId) {
            return {
              nodeId: parseInt(employeeId, 10),
              nodeName: data[employeeId].comma_name,
            };
          });
          $('#groups-select').data('selected-nodes', selectedArray);

          updateSelection();
          renderSelections();
        }
      });
    }
  }

  function setupGroupTree() {
    var $root = $('#groups-select');

    $root.data('selected-nodes', []);
    $root.data('selected-groups-nodes', []);

    bindChange($root);
    bindNodesClicks($root);
    bindDeactivated();
    bindSelect($root);
    bindScroll();
    bindClearSelection($root);
    bindClearFilters();
    bindFocus($root);
    restoreState();

    // Close Dropdown if click outside of it
    $(document).click(event => {
      if ($(event.target).closest($root).length === 0) {
        closeDropDown($root);
      }
    });

    $('a[data-toggle="pill"]').on('shown.bs.tab', function (e) {
      if ($(e.target).attr('href') === '#teams') {
        $('#team_or_group').val('teams').change();
        clearAllSelection();
      }
    });
  }

  if ($('#groups-select').length) {
    setupGroupTree();
  }
});
